import React from 'react'
import {RouterProp} from '../data'

export const useSetTitle = (title: string, props: RouterProp): void => {
React.useEffect(() => {
    props.handleTitle(title)
}, [title, props])
}